export default __webpack_public_path__ + "static/nakahara_img1-2e5ad6b3556ac37ff11ebcc2f248750f.jpg";